import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map } from 'immutable'
import { getBoundActions } from '../../actions/index'
import DetailPageV3TopModule from './DetailPageV3TopModule'
import DetailPageV3DefaultLayout from './DetailPageV3DefaultLayout'
import DetailPageV3Title from './DetailPageV3Title'
import DetailPageV3Description from './DetailPageV3Description'
import DetailPageV3Info from './DetailPageV3Info'
import DetailPageV3ActionBar from './DetailPageV3ActionBar'
import DetailPageV3InfoMeta from './DetailPageV3InfoMeta'
import DetailPageV3Related from './DetailPageV3Related'
import DetailPageV3ActionButtons from './DetailPageV3ActionButtons/DetailPageV3ActionButtons'
import DetailPageV3ActionShare from './DetailPageV3ActionButtons/DetailPageV3ActionShare'
import DetailPageV3ActionCopyLink from './DetailPageV3ActionButtons/DetailPageV3ActionCopyLink'
import DetailPageV3ActionPlaylist from './DetailPageV3ActionButtons/DetailPageV3ActionPlaylist'
import DetailPageV3ActionVote from './DetailPageV3ActionButtons/DetailPageV3ActionVote'
import DetailPageV3MetaSeries from './DetailPageV3MetaSeries'
import DetailPageV3InfoMetaItems from './DetailPageV3InfoMetaItems'
import DetailPageV3NextEpisode from './DetailPageV3NextEpisode'
import DetailPageV3CommentsView from './DetailPageV3CommentsView'

const DetailPageV3Episode = (props) => {
  const {
    detailData = Map(),
    staticText,
    location,
    history,
    apolloClient,
    uiLocation,
  } = props

  const ga4EventData = {
    content_name: detailData.get('title'),
    content_id: detailData.get('contentId'),
    content_type: detailData.get('contentType'),
    parent_series_name: detailData.get('seriesTitle'),
    parent_series_id: detailData.get('seriesId'),
    ui_location: uiLocation,
  }

  return (
    <div className="detail-page-v3 detail-page-v3--episode">
      <DetailPageV3TopModule
        detailData={detailData}
        location={location}
        history={history}
        apolloClient={apolloClient}
        ga4EventData={ga4EventData}
      />
      <DetailPageV3DefaultLayout
        content={
          <>
            <DetailPageV3Title
              title={detailData.get('title')}
              moreButtonLabel={staticText.get('moreInfo')}
              mobilePopupTitle={staticText.get('description')}
              moreContent={
                <>
                  <DetailPageV3Description description={detailData.get('description')} />
                  <DetailPageV3InfoMeta detailData={detailData} />
                </>
              }
            />

            <DetailPageV3ActionBar
              metaItems={
                <>
                  <DetailPageV3MetaSeries detailData={detailData} />
                  <DetailPageV3InfoMetaItems detailData={detailData} isInline={false} />
                </>
              }
              actionButtons={
                <DetailPageV3ActionButtons
                  primaryButtons={
                    <>
                      <DetailPageV3ActionVote
                        detailData={detailData}
                        ga4EventData={ga4EventData}
                      />
                      <DetailPageV3ActionShare
                        detailData={detailData}
                        ga4EventData={ga4EventData}
                      />
                    </>
                  }
                  hiddenButtons={
                    <>
                      <DetailPageV3ActionCopyLink
                        detailData={detailData}
                      />
                      <DetailPageV3ActionPlaylist
                        detailData={detailData}
                        ga4EventData={ga4EventData}
                      />
                    </>
                  }
                />
              }
            />

            <DetailPageV3Info
              text={detailData.get('description')}
              moreButtonLabel={staticText.get('moreInfo')}
            >
              <>
                <DetailPageV3Description description={detailData.get('description')} />
                <DetailPageV3InfoMeta detailData={detailData} />
              </>
            </DetailPageV3Info>

            <div id="commentsBlock"></div>
            <DetailPageV3CommentsView
              title={staticText.get('comments')}
              moreButtonLabel={`${staticText.get('viewAllComments')}`}
              detailData={detailData}
            />
          </>
        }
        rightRail={
          <>
            <DetailPageV3NextEpisode detailData={detailData} title={staticText.get('nextEpisode')} />
            <DetailPageV3Related detailData={detailData} title={staticText.get('relatedVideos')} />
          </>
        }
      />
    </div>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3Episode)
